import { render } from "./ToolbarButton.vue?vue&type=template&id=337905d6&scoped=true&ts=true"
import script from "./ToolbarButton.vue?vue&type=script&lang=ts"
export * from "./ToolbarButton.vue?vue&type=script&lang=ts"

import "./ToolbarButton.vue?vue&type=style&index=0&id=337905d6&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-337905d6"]])

export default __exports__